// extracted by mini-css-extract-plugin
export default {"mainContainer":"FileUploadsHistory_mainContainer__sClws"};